import { featuresResponseSchema, type FeatureFlagName } from '@pm-tool/shared';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api-client';

export const featuresQuery = queryOptions({
  queryKey: ['features'],
  queryFn: ({ signal }) =>
    apiRequest({ path: '/v1/features', schema: featuresResponseSchema, signal }),
  staleTime: 5 * 60_000,
});

/**
 * Whether a feature is enabled for the current user. False while loading.
 * UI convenience only – the API enforces flags itself (requireFeature).
 */
export function useFeature(name: FeatureFlagName): boolean {
  const { data } = useQuery(featuresQuery);
  return data?.flags[name] ?? false;
}
